import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  min-height: 100vh;
  padding: 29px 0 53px;
  background-color: ${({ theme }) => theme.colors.grey100};
  box-sizing: border-box;
`;

export const LogoImg = styled.img`
  width: 98px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 53%;
  height: 673px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 10px;
  box-sizing: border-box;
`;
